import { StyleSheet } from '../react-native-components';

const styles = StyleSheet.create({
  genericNoDataCardContainer: {
    justifyContent: 'center',
    minHeight: 250,
    padding: 10,
    alignItems: 'center'
  },
  genericNoDataIconContainer: {
    backgroundColor: '#F5F5F5',
    padding: 27,
    borderRadius: 50
  },
  titleText: {
    marginTop: 16,
    marginButtom: 12
  },
  noDataActionButtonContainer: {
    borderColor: '#186FB8',
    width: 100,
    marginTop: 16
  },
  buttonText: {
    color: '#186FB8'
  },
  noDataSubTitleText: {
    color: '#6C6C6C',
    textAlign: 'center'
  }
});

export default styles;
